/**
 * The five states a run can be in, across the top of a tab.
 *
 * The same words and colours the rows use — `AOP_RUN_STATES` is the one place
 * they are defined — so narrowing by a stage and reading a row afterwards are
 * the same vocabulary rather than two descriptions of the same thing.
 *
 * Every stage is a question the service answers: `state` and `outcome` are both
 * filters now, and each page says how many match. Clicking the selected stage
 * again clears it, which is the only way back to everything.
 */

import React, { FC } from 'react';
import { PipelineCounts } from '../pipeline_counts/PipelineCounts';
import {
	AOPRunState,
	AOPRunStateCounts,
	AOP_RUN_ORDER,
	AOP_RUN_STATES,
} from './utils/AOPExecutionStates';

interface AOPRunFunnelProps {
	counts: AOPRunStateCounts;
	selected: AOPRunState | null;
	onSelect: (runState: AOPRunState | null) => void;
}

export const AOPRunFunnel: FC<AOPRunFunnelProps> = ({ counts, selected, onSelect }) => (
	<PipelineCounts
		pipelineCounts={AOP_RUN_ORDER.map((runState) => ({
			name: runState,
			displayName: AOP_RUN_STATES[runState].label,
			// A count that has not arrived shows nothing rather than a zero, which
			// would say there are none.
			count: counts[runState] === undefined ? '' : counts[runState],
			/*
			  Matched against the `filters` below rather than against the service's
			  own parameters: a stage is one of our five, and two of them share
			  `state: finished`, so comparing the request's filters would light up
			  more than one chevron.
			*/
			filter: { runState },
			toggleActive: () => onSelect(runState),
			toggleInactive: () => onSelect(null),
		}))}
		filters={{ runState: selected }}
	/>
);

export default AOPRunFunnel;
